/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable global-require */
import axios from 'axios';
import React, { useEffect, useState, useContext } from 'react';
import { Image } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { SpinnerDotted } from 'spinners-react';
import { LOADER_COLOR, LOADER_SIZE } from '../../constants/loaderConstants';
import { getCookies } from '../../hooks/useCookies';
import { TableContext } from '../../contexts/tableContext';
import styles from './viewTicket.module.scss';
import { CapitalizeFirstLetter, DateFormatter } from '../../utilityFunctions/utilsFunctions';
import envValues from '../../enviornment';
import { Entry } from '../../redux/entrySlice';
import defaultImg from '../../assets/user_default.svg';
import CancelTicket from '../../components/CancelTicket/CancelTicket';
import { SERVER_BASE_URL } from '../../redux/apiConstants';

function ViewTicket() {
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const navigate = useNavigate();
  const params = useParams();
  let ticketId;
  const token = `Bearer ${getCookies('Token')}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [booking, setBooking] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const dispatch = useDispatch();
  let statusCode;
  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/booking/my-booked-ticket/${ticketId}`, {
        method: 'GET',
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log(res, 'resssssss');
          setDetails(res?.data?.ticket);
          setBooking(res?.data?.booking);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  function formatPhoneNumber(number) {
    if (!number || typeof number !== 'string') {
      return 'Invalid phone number';
    }
    let converted;
    if (number.startsWith('+1')) {
      const phoneNumber = number.replace(/\+1|\D/g, '');
      converted = `+1 (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(
        6,
        10
      )}`;
    } else if (number.startsWith('+91')) {
      const phoneNumber = number.replace(/\+91|\D/g, '');
      converted = `+91 ${phoneNumber.slice(0, 5)}-${phoneNumber.slice(5)}`;
    } else {
      converted = number;
    }
    return converted;
  }

  const confirmDelete = async () => {
    setDeleteLoading(true);

    try {
      const response = await axios.post(
        `${SERVER_BASE_URL}/booking/cancel-booking/${details.id || details?._id}`,
        {
          cancelledBy: getCookies('USERID'),
        },
        {
          headers: {
            Authorization: `Bearer ${getCookies('Token')}`,
          },
        }
      );

      if (response.data.code === 200) {
        toast.success('Ticket has been cancelled.');
        navigate(-1);
        setDeleteLoading(false);
        setDeleteModal(false);
      } else {
        toast.error('Something went wrong.');
        setDeleteModal(false);
        setDeleteLoading(false);
      }
    } catch (error) {
      toast.error('Something went wrong.');
      setDeleteModal(false);
      setDeleteLoading(false);
    }
  };

  function handleDelete() {
    setDeleteModal(true);
  }

  const handleDeleteClose = () => setDeleteModal(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    ticketId = params.ticketId;
    getUserDetails();
    setDashboardHeader('Ticket Details');
  }, []);
  return (
    <div className={styles[bodyStyle]}>
      <CancelTicket
        show={deleteModal}
        handleClose={handleDeleteClose}
        onConfirm={confirmDelete}
        onCancel={handleDeleteClose}
        message="Do you really want to cancel this ticket? "
        loading={deleteLoading}
      />
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <div className="form_head">
          <div
            value="Back"
            onClick={() => {
              navigate(-1);
            }}
            className={`${styles.arrowback} backBtn`}
          >
            <svg
              className="mr-1"
              width="17"
              height="14"
              viewBox="0 0 17 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                fill=""
              />
            </svg>
            Back
          </div>
          {details?.showId?.status === 'created' &&
            !booking?.isVerified &&
            details?.paymentStatus === 'booked' && (
              <div className={styles.dlt_btn}>
                <div>
                  <span className="sub_btn_del deletebtn">
                    <button
                      className={styles.formbtndelete}
                      type="button"
                      onClick={handleDelete}
                      // disabled={submiting}
                      value="Cancel Ticket"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9199 22.75C5.99992 22.75 1.16992 17.93 1.16992 12C1.16992 6.07 5.99992 1.25 11.9199 1.25C17.8399 1.25 22.6699 6.07 22.6699 12C22.6699 17.93 17.8499 22.75 11.9199 22.75ZM11.9199 2.75C6.81992 2.75 2.66992 6.9 2.66992 12C2.66992 17.1 6.81992 21.25 11.9199 21.25C17.0199 21.25 21.1699 17.1 21.1699 12C21.1699 6.9 17.0199 2.75 11.9199 2.75Z"
                          fill="white"
                        />
                        <path
                          d="M15.9199 12.75H7.91992C7.50992 12.75 7.16992 12.41 7.16992 12C7.16992 11.59 7.50992 11.25 7.91992 11.25H15.9199C16.3299 11.25 16.6699 11.59 16.6699 12C16.6699 12.41 16.3399 12.75 15.9199 12.75Z"
                          fill="white"
                        />
                      </svg>
                      Cancel Ticket
                    </button>
                  </span>
                </div>
              </div>
            )}
        </div>
        <div id={styles.addform}>
          {loading ? (
            <SpinnerDotted
              size={LOADER_SIZE}
              color={LOADER_COLOR}
              style={{
                left: '50%',
                position: 'relative',
                textAlign: 'center',
                top: '50%',
              }}
            />
          ) : (
            <div className="djfhdj">
              <div className={`${styles.attent_details} attent_details`}>
                <div className="">
                  <div className="">
                    {details && (
                      <div className="col-md-12">
                        <div className={styles.attent_details_contain}>
                          <div className={`${styles.attent_details_inner} attent_details_inner`}>
                            <div
                              className={`${styles.attent_details_inner_l} attent_details_inner_l`}
                            >
                              <Image src={details?.showId?.image} alt="" />
                            </div>
                            <div className="attent_details_inner_r">
                              <div className="attent_details_row">
                                <div className="attent_details_row_box">
                                  <p>Name</p>
                                  <h5>
                                    {details?.bookingForSomeone
                                      ? details?.userId?.name
                                      : details?.userName}
                                  </h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Booking ID</p>
                                  <h5>{details?.bookingId}</h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Phone Number</p>
                                  <h5>
                                    {formatPhoneNumber(
                                      details?.bookingForSomeone
                                        ? details?.userId?.phone
                                        : details?.phone
                                    )}
                                  </h5>
                                </div>
                              </div>
                              <div className="attent_details_row">
                                <div className="attent_details_row_box">
                                  <p>Transaction Id</p>
                                  <h5>{details?.transactionId}</h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Total Payment</p>
                                  <h5>${details?.totalAmount?.toFixed(2)}</h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Ticket Status</p>
                                  <h5>
                                    {details?.paymentStatus &&
                                      CapitalizeFirstLetter(details?.paymentStatus)}
                                  </h5>
                                </div>
                              </div>
                              <div className="attent_details_row">
                                <div className="attent_details_row_box">
                                  <p>Net Amount</p>
                                  <h5>${details?.totalPrice?.toFixed(2)}</h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Convenience Fee</p>
                                  <h5>${details?.convinienceFee?.toFixed(2)}</h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Payment Mode</p>
                                  <h5>
                                    {details?.paymentMethod &&
                                      CapitalizeFirstLetter(details?.paymentMethod)}
                                  </h5>
                                </div>
                              </div>
                              <div className="attent_details_row">
                                <div className="attent_details_row_box">
                                  <p>
                                    Discount
                                    {details?.couponCode ? ` (${details.couponCode})` : ''}
                                  </p>
                                  <h5>
                                    $
                                    {details?.couponDiscount
                                      ? details?.couponDiscount?.toFixed(2)
                                      : 0}
                                  </h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Email</p>
                                  <h5>
                                    {details?.bookingForSomeone
                                      ? details?.userId?.email
                                      : details?.email}
                                  </h5>
                                </div>
                                <div className="attent_details_row_box">
                                  <p>Booking Date & Time</p>
                                  <h5>
                                    {details?.bookedDate &&
                                      `${DateFormatter(details?.bookedDate, 'toEventViewDate')}, 
                                  ${DateFormatter(details?.bookedDate, 'toTime')}`}
                                  </h5>
                                </div>
                              </div>
                              <div className="attent_details_row attent_details_row_last">
                                {details?.showId?.eventType === 'booking' && (
                                  <div className="attent_details_row_box">
                                    <p>Seat ({details?.numberOfTicketsBooked})</p>
                                    <h5>{details?.seatsBooked}</h5>
                                  </div>
                                )}
                                {/* {details?.formResponse?.timeSlot && (
                                  <div className="attent_details_row_box">
                                    <p>Sadhya Slot</p>
                                    <h5>{details?.formResponse?.timeSlot}</h5>
                                  </div>
                                )} */}
                                {details?.formResponse?.donationAmount > 0 && (
                                  <>
                                    <div className="attent_details_row_box">
                                      <p>Donation Amount</p>
                                      <h5>${details?.formResponse?.donationAmount?.toFixed(2)}</h5>
                                    </div>
                                    <div className="attent_details_row_box">
                                      <p />
                                    </div>
                                  </>
                                )}
                                {details?.formResponse?.partnerName &&
                                  details?.formResponse?.partnerName !== '' && (
                                    <>
                                      <div className="attent_details_row_box">
                                        <p>Partner Name</p>
                                        <h5>{details?.formResponse?.partnerName}</h5>
                                      </div>
                                      <div className="attent_details_row_box">
                                        <p />
                                      </div>
                                    </>
                                  )}
                                {details?.formResponse?.ward && details?.formResponse?.ward !== '' && (
                                  <>
                                    <div className="attent_details_row_box">
                                      <p>Ward</p>
                                      <h5>{details?.formResponse?.ward}</h5>
                                    </div>
                                    <div className="attent_details_row_box">
                                      <p />
                                    </div>
                                  </>
                                )}
                              </div>
                              {details?.formResponse?.facts && details?.formResponse?.facts !== '' && (
                                <div className="attent_details_row attent_details_row_last interesting_fact">
                                  <div className="attent_details_row_box">
                                    <p>Interesting Facts</p>
                                    <h5>{details?.formResponse?.facts}</h5>
                                  </div>
                                </div>
                              )}
                              <div className="attent_details_row attent_details_row_last interesting_fact">
                                {details?.formResponse?.parishId &&
                                  details?.formResponse?.parishId !== '' &&
                                  details?.formResponse?.parishId !== 'undefined' && (
                                    <div className="attent_details_row_box">
                                      <p>Parish Id</p>
                                      <h5>{details?.formResponse?.parishId}</h5>
                                    </div>
                                  )}
                                {details?.formResponse?.isRampWalk &&
                                  details?.formResponse?.isRampWalk !== '' && (
                                    <div className="attent_details_row_box">
                                      <p>Ramp Walk</p>
                                      <h5>{details?.formResponse?.isRampWalk}</h5>
                                    </div>
                                  )}
                              </div>
                              {details?.bookingForSomeone && (
                                <div className={styles.bookforsomeonesec}>
                                  <h5 className={styles.bookedForSomeone}>Booked For Someone</h5>
                                  <div className="attent_details_row" id="attent_details_row1">
                                    <div className="attent_details_row_box">
                                      <p>Name</p>
                                      <h5>{details?.userName}</h5>
                                    </div>
                                    <div className="attent_details_row_box">
                                      <p>Email</p>
                                      <h5>{details?.email}</h5>
                                    </div>
                                    <div className="attent_details_row_box">
                                      <p>Phone</p>
                                      <h5>{formatPhoneNumber(details?.phone)}</h5>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          {details?.showId?.eventType === 'booking' &&
                            (() => {
                              const participants = details?.formResponse?.participants || [];

                              const validParticipants = participants.filter(
                                (p) =>
                                  (p?.name && p.name.trim() !== '') ||
                                  (p?.email && p.email.trim() !== '') ||
                                  (p?.phone && p.phone.trim() !== '')
                              );

                              return validParticipants.length > 0 ? (
                                <div className={styles.participants_contain}>
                                  <h1>Additional Participant Details</h1>
                                  <div className={styles.additional_participant}>
                                    {validParticipants.map((participant, index) => (
                                      <div
                                        key={index}
                                        className={styles.additional_participant_inner}
                                      >
                                        <div className={styles.participants_row}>
                                          <div
                                            className={`${styles.participants_row_box} ${styles.participants_name}`}
                                          >
                                            <p>Name</p>
                                            <h5>{participant?.name || '-'}</h5>
                                          </div>
                                          <div
                                            className={`${styles.participants_row_box} ${styles.participants_email}`}
                                          >
                                            <p>Email</p>
                                            <h5>{participant?.email || '-'}</h5>
                                          </div>
                                          <div
                                            className={`${styles.participants_row_box} ${styles.participants_mobile}`}
                                          >
                                            <p>Mobile Number</p>
                                            <h5>
                                              {participant?.phone && participant?.phone.length > 4
                                                ? formatPhoneNumber(participant.phone)
                                                : '-'}
                                            </h5>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : null;
                            })()}

                          {details?.showId?.eventType === 'form' && (
                            <>
                              {details?.showId?.eventCategory === 'Marathon' ? (
                                <div className={styles.participants_contain}>
                                  <h1>Participants Details</h1>
                                  <div className={styles.participants_row}>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_name}`}
                                    >
                                      <p>Name</p>
                                      <h5>{details?.formResponse?.name}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_email}`}
                                    >
                                      <p>Email</p>
                                      <h5>{details?.formResponse?.email}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_mobile}`}
                                    >
                                      <p>Mobile Number</p>
                                      <h5>{formatPhoneNumber(details?.formResponse?.phone)}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_gender}`}
                                    >
                                      <p>Gender</p>
                                      <h5>{details?.formResponse?.gender}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_age}`}
                                    >
                                      <p>Age</p>
                                      <h5>{details?.formResponse?.age}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_amount}`}
                                    >
                                      <p>Amount</p>
                                      <h5>
                                        $
                                        {details?.formResponse?.age > 13
                                          ? details?.showId?.pricing[0]?.price?.toFixed(2)
                                          : details?.showId?.pricing[1]?.price?.toFixed(2)}
                                      </h5>
                                    </div>
                                  </div>
                                  {details?.showId?.eventType === 'form' &&
                                    details?.formResponse?.participants &&
                                    details?.formResponse?.participants?.length > 0 && (
                                      <div className={styles.additional_participant}>
                                        <h1>Additional Participant Details</h1>
                                        {details?.formResponse?.participants?.map((participant) => {
                                          const isAdult = participant?.age > 13;
                                          return (
                                            <div className={styles.additional_participant_inner}>
                                              <div className={styles.participants_row}>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_name}`}
                                                >
                                                  <p>Name</p>
                                                  <h5>{participant?.name}</h5>
                                                </div>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_email}`}
                                                >
                                                  <p>Email</p>
                                                  <h5>
                                                    {participant?.email ? participant?.email : '-'}
                                                  </h5>
                                                </div>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_mobile}`}
                                                >
                                                  <p>Mobile Number</p>
                                                  <h5>
                                                    {participant?.phone &&
                                                    participant?.phone?.length > 4
                                                      ? formatPhoneNumber(participant?.phone)
                                                      : '-'}
                                                  </h5>
                                                </div>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_gender}`}
                                                >
                                                  <p>Gender</p>
                                                  <h5>{participant?.gender}</h5>
                                                </div>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_age}`}
                                                >
                                                  <p>Age</p>
                                                  <h5>{participant?.age}</h5>
                                                </div>
                                                <div
                                                  className={`${styles.participants_row_box} ${styles.participants_amount}`}
                                                >
                                                  <p>Amount</p>
                                                  <h5>
                                                    $
                                                    {isAdult
                                                      ? details?.showId?.pricing[0]?.price?.toFixed(
                                                          2
                                                        )
                                                      : details?.showId?.pricing[1]?.price?.toFixed(
                                                          2
                                                        )}
                                                  </h5>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <div className={styles.participants_contain}>
                                  <h1>Attendee Details</h1>
                                  <div className={styles.participants_row}>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_name}`}
                                    >
                                      <p>Name</p>
                                      <h5>
                                        {details?.formResponse?.name}{' '}
                                        {details?.formResponse?.lastName}
                                      </h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_email}`}
                                    >
                                      <p>Email</p>
                                      <h5>{details?.formResponse?.email}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_mobile}`}
                                    >
                                      <p>Mobile Number</p>
                                      <h5>{formatPhoneNumber(details?.formResponse?.phone)}</h5>
                                    </div>
                                    {/* <div
                                      className={`${styles.participants_row_box} ${styles.participants_gender}`}
                                    >
                                      <p>Donation</p>
                                      <h5>${details?.formResponse?.donationAmount.toFixed(2)}</h5>
                                    </div> */}
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_age}`}
                                    >
                                      <p>Adults</p>
                                      <h5>{details?.formResponse?.numberOfAdults}</h5>
                                    </div>
                                    <div
                                      className={`${styles.participants_row_box} ${styles.participants_amount}`}
                                    >
                                      <p>Kids</p>
                                      <h5>{details?.formResponse?.numberOfKids}</h5>
                                    </div>
                                  </div>
                                  <div
                                    className={styles.participants_row}
                                    style={{ paddingTop: '20px' }}
                                  >
                                    {details?.formResponse?.numberOfGuests &&
                                    details?.formResponse?.numberOfGuests > 0 ? (
                                      <div
                                        className={`${styles.participants_row_box} ${styles.participants_name}`}
                                      >
                                        <p>Visiting Parents</p>
                                        <h5>{details?.formResponse?.numberOfGuests}</h5>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {details?.formResponse?.numberOfKidsUnder5 &&
                                    details?.formResponse?.numberOfKidsUnder5 > 0 ? (
                                      <div
                                        className={`${styles.participants_row_box} ${styles.participants_amount}`}
                                      >
                                        <p>Kids Under 5</p>
                                        <h5>{details?.formResponse?.numberOfKidsUnder5}</h5>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewTicket;
